module.exports = __webpack_public_path__ + "65e7e09d56a275954e259d86820eed33.svg";